module.exports = __webpack_public_path__ + "media/packs/images/flags/TH-044496730b3e1adb7d911d438452d246.png";